import { useIntlTokens } from "@/src/components/mobile/useIntlTokens";
import { useCallback } from "react";
import { useIntl } from "react-intl";

type Role = "ADMIN" | "MANAGER" | "CO_WORKER" | "COWORKER_GROUP" | "READ_ONLY";
export function useGetRoleLabels() {
  const intl = useIntl();
  const intl_tokens = useIntlTokens();
  return useCallback(
    (role: Role, plural: boolean = false) => {
      switch (role) {
        case "READ_ONLY":
          return intl_tokens.ReadOnly;
        case "COWORKER_GROUP":
          return intl.formatMessage(
            {
              defaultMessage:
                "{count, plural, one {Group Account} other {Group Accounts}}",
              description: "Roles.COWORKER_GROUP label",
            },
            {
              count: plural ? 2 : 1,
            }
          );
        case "ADMIN":
          return intl.formatMessage(
            {
              defaultMessage: "{count, plural, one {Admin} other {Admins}}",
              description: "Roles.ADMIN label",
            },
            {
              count: plural ? 2 : 1,
            }
          );
        case "MANAGER":
          return intl.formatMessage(
            {
              defaultMessage: "{count, plural, one {Manager} other {Managers}}",
              description: "Roles.Manager label",
            },
            {
              count: plural ? 2 : 1,
            }
          );
        case "CO_WORKER":
          return intl.formatMessage(
            {
              defaultMessage:
                "{count, plural, one {Co-Worker} other {Co-Workers}}",
              description: "Roles.Co-Worker label",
            },
            {
              count: plural ? 2 : 1,
            }
          );
      }
    },
    [intl, intl_tokens.ReadOnly]
  );
}

export function useGetRoleDescription() {
  const intl = useIntl();
  return useCallback(
    (role: Role) => {
      switch (role) {
        case "COWORKER_GROUP":
          return "";
        case "ADMIN":
          return intl.formatMessage({
            defaultMessage: "Full access to all features.",
            description: "UserAdminInviteUserRole: desc admin",
          });
        case "MANAGER":
          return intl.formatMessage({
            defaultMessage:
              "Like Co-worker, but can also make changes to checklists.",
            description: "UserAdminInviteUserRole: desc manager",
          });
        case "CO_WORKER":
          return intl.formatMessage({
            defaultMessage: "Can work with Storesprint in daily operations.",
            description: "UserAdminInviteUserRole: desc co-worker",
          });
      }
    },
    [intl]
  );
}
